module.exports = __webpack_public_path__ + "static/team-small-c72e251cce7e00b75d5d7cf6bb2b593a.webp";